import builder from '../builder';
import AccountingInvoiceHand from '../../streamline-icons/light/accounting-invoice-hand.svg';

export default builder('IconAccountingInvoiceHandLight', AccountingInvoiceHand);
